import Module from '../Module';
import Item from "../parts/Item";
import {$t, getIconMap} from "../i18n";

export default class Accommodation extends Module {
    constructor(title, index, categories, services, firstQuestion) {
        // Chain constructor with super
        super(title, index, 'accommodation', firstQuestion);
        this._title = title || $t('mod.accommodation.title')
        this._firstQuestion = firstQuestion || $t('mod.accommodation.firstQuestion')
        this._categories = categories;
        this._items = [];

        this._iconMap = getIconMap()
        this._defaultIcon = 'question';
        this._iconPrefix = 'fas fa-';

        this.services = services;
        this._userServices = [];
        this._message = '';
        this._configuratorActive = false;
        this._catSelect = '';
        if (this._categories.length === 1) {
            this.addItem(0, null, 0);
        }
    }


    get catSelect() {
        return this._catSelect;
    }

    set catSelect(cat) {
        this._catSelect = cat;
    }

    get configuratorActive() {
        return this._configuratorActive;
    }

    set configuratorActive(configuratorActive) {
        this._configuratorActive = configuratorActive;
    }

    get items() {
        return this._items;
    }

    get categories() {
        return this._categories;
    }

    get services() {
        return this._services;
    }

    set services(services) {
        services = services || [];
        services.forEach(service => {
            if (!service.icon) {
                service.faIcon = this._iconPrefix + this.iconFromTitle(service.title)
                // service.iconifyIcon = `fa-pro-solid:${this.iconFromTitle(service.title)}`
            }
        });
        this._services = services;
    }

    get userServices() {
        return this._userServices;
    }

    set userServices(userServices) {
        this._userServices = userServices;
    }

    get message() {
        return this._message;
    }

    set message(message) {
        this._message = message;
    }

    resetItems() {
        this._catSelect = '';
        this._items = [];
    }

    addItem(adults, category, index) {
        const newItem = new Item(adults, category, index);
        this._items.push(newItem);
        return newItem;
    }

    removeItem(index) {
        this._items.splice(index, 1);
    }

    getItemByIndex(index) {
        return this._items[index];
    }

    fillDummyData() {
        this._message = 'Dies ist eine Test-Nachricht der MANET Marketing GmbH. Bitte ignorieren Sie diese Anfrage!';
        // this._userServices = this.services.slice(0, Math.floor(Math.random() * this._services.length)).map(s => s.title);
        this._userServices = this.services.map(s => s.title);
        this._items = [];
        this._configuratorActive = true;
        const rndItemCount = Math.floor(Math.random() * 3) + 1;
        for (let i = 0; i < rndItemCount; i++) {
            const rndCategoryIndex = Math.floor(Math.random() * this.categories.length);
            const newItem = this.addItem(Math.floor(Math.random() * 10) + 1, this.categories[rndCategoryIndex].options[0], rndCategoryIndex);
            newItem.active = true;
            newItem.fillDummyData(this.categories);
        }
    }

    removeDummyData() {
        this._items = [new Item(0, null, 0)];
        this.message = '';
        this.userServices = [];
        this._configuratorActive = false;
    }

    iconFromTitle(title) {
        let icon = this._defaultIcon;
        Object.keys(this._iconMap).forEach(titleSubString => {
            if (title.indexOf(titleSubString) > -1) {
                icon = this._iconMap[titleSubString];
                return;
            }
        });

        return icon;
    }
}
